import { obtenerTotalCuposVigentes } from '../../Cupos/actions'
import { obtenerMonitorPorBuque } from '../../Embarque/actions'
import obtenerMercaderiaEnTerminal, { obtenerTotalStock } from '../../Stock/actions'
import { obtenerTotales } from './index'

export function monitorDeEmbarque () {
  return obtenerMonitorPorBuque()
}

export function totalCupos () {
  return obtenerTotalCuposVigentes()
}

export function totalesCircuito () {
  return obtenerTotales()
}

export function totalStock () {
  return obtenerTotalStock()
}

export function totalMercaderia () {
  return obtenerMercaderiaEnTerminal()
}
